/* GENERATED by tools/dc-port from design-reference/PointFive OS Original.dc.html — DOM-faithful view.
 * Do not hand-edit layout/style literals; regenerate with `pnpm --filter @pointfive/dc-port port`. */
import { Fragment } from 'react';
import * as dc from '@/lib/dc';
import { RailButton } from '@pointfive/ui';
import type { ViewModel } from './view-model';
import { SCREENS } from './screens';

export function ShellView({ m }: { m: ViewModel }) {
  return (
    <>
      <div className="pf-aurora"></div>
      <div
        data-theme={m.themeAttr}
        style={{
          position: 'relative',
          zIndex: '1',
          display: 'flex',
          height: '100vh',
          overflow: 'hidden',
          fontSize: '13px',
          background: 'var(--bg)',
          color: 'var(--text)',
        }}
      >
        {' '}
        {m.navClosed ? (
          <>
            {' '}
            <div
              style={{
                flex: 'none',
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
                padding: '12px 0 12px 12px',
                width: '68px',
              }}
            >
              {' '}
              <div
                title="PointFive OS"
                style={{
                  width: '56px',
                  height: '52px',
                  flex: 'none',
                  borderRadius: '18px',
                  background: 'var(--rail)',
                  color: 'var(--rail-ink)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: 'var(--shadow-card)',
                }}
              >
                <i className="ph-fill ph-asterisk" style={{ fontSize: '20px' }}></i>
              </div>{' '}
              <div
                className="rail-slab"
                style={{
                  position: 'relative',
                  flex: '0 1 auto',
                  minHeight: '0',
                  display: 'flex',
                  flexDirection: 'column',
                  width: '56px',
                  borderRadius: '22px',
                  background: 'var(--rail)',
                  boxShadow: 'var(--shadow-card)',
                  overflow: 'hidden',
                }}
              >
                {' '}
                <button
                  className="scp-98f6321"
                  onClick={m.toggleFold}
                  title={dc.a(m.foldTitle)}
                  aria-label={dc.a(m.foldTitle)}
                  style={{
                    flex: 'none',
                    alignSelf: 'center',
                    // 44px hit area, 34px visual: transparent padding with compensating margins keeps every
                    // rendered pixel where the design put it while a thumb still lands (SM-P6-02 touch targets).
                    marginTop: '5px',
                    marginBottom: '-5px',
                    width: '44px',
                    height: '44px',
                    padding: '5px',
                    borderRadius: '11px',
                    border: 'none',
                    background: 'transparent',
                    color: 'var(--rail-ink)',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <i className={`ph ${dc.s(m.foldIcon)}`} style={{ fontSize: '18px' }}></i>
                </button>{' '}
                <div
                  style={{
                    flex: 'none',
                    alignSelf: 'center',
                    width: '22px',
                    height: '1px',
                    background: 'var(--rail-line)',
                    margin: '5px 0 7px',
                  }}
                ></div>{' '}
                <div
                  className="rail-viewport"
                  style={{
                    position: 'relative',
                    flex: '1 1 auto',
                    minHeight: '0',
                    overflow: 'hidden',
                    display: 'flex',
                    width: '56px',
                  }}
                >
                  {' '}
                  <div
                    className="rail-scroll"
                    style={{
                      flex: '1 1 auto',
                      minHeight: '0',
                      overflowY: 'auto',
                      padding: '0 0 10px',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      gap: '4px',
                      width: '56px',
                    }}
                  >
                    {' '}
                    {(m.navMain ?? []).map((r, i212) => (
                      <Fragment key={i212}>
                        {' '}
                        <RailButton
                          bg={r?.railBg}
                          fg={r?.railFg}
                          icon={r?.icon}
                          onClick={r?.go}
                          title={dc.s(r?.label)}
                          aria-label={dc.s(r?.label)}
                          hoverClass="scp-98f6321"
                        />{' '}
                      </Fragment>
                    ))}{' '}
                  </div>{' '}
                  <span className="rail-fade rail-fade-top" aria-hidden="true"></span>{' '}
                  <span className="rail-fade rail-fade-bottom" aria-hidden="true">
                    <i className="ph ph-caret-down"></i>
                  </span>{' '}
                </div>{' '}
              </div>{' '}
              <div
                className="rail-spacer"
                style={{
                  flex: '1 1 auto',
                  minHeight: '44px',
                  containerType: 'size',
                  borderRadius: '22px',
                  background: 'var(--rail-soft)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '56px',
                  overflow: 'hidden',
                }}
              >
                {' '}
                <span
                  className="rail-label"
                  style={{
                    writingMode: 'vertical-rl',
                    transform: 'rotate(180deg)',
                    fontSize: '9px',
                    letterSpacing: '0.22em',
                    textTransform: 'uppercase',
                    color: 'var(--muted2)',
                    fontWeight: '600',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {dc.t(m.modeLabelUpper)}
                </span>{' '}
                <i
                  className={`ph ${dc.s(m.modeIcon)} rail-mode-glyph`}
                  style={{ fontSize: '16px', color: 'var(--muted2)' }}
                ></i>{' '}
              </div>{' '}
              <div
                style={{
                  flex: 'none',
                  marginTop: 'auto',
                  borderRadius: '22px',
                  background: 'var(--rail-soft)',
                  padding: '10px 0',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '6px',
                  width: '56px',
                }}
              >
                {' '}
                <button
                  className="scp-b722f2b"
                  onClick={m.toggleTheme}
                  title="Toggle theme"
                  style={{
                    width: '38px',
                    height: '38px',
                    borderRadius: '12px',
                    border: 'none',
                    background: 'transparent',
                    color: 'var(--muted)',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <i className={`ph ${dc.s(m.themeIcon)}`} style={{ fontSize: '17px' }}></i>
                </button>{' '}
                <button
                  className="scp-98f6321"
                  onClick={m.navSettings?.go}
                  title="Settings"
                  aria-label="Settings"
                  style={dc.css(
                    `width:38px;height:38px;border-radius:13px;border:none;background:${dc.s(m.navSettings?.railBottomBg)};color:${dc.s(m.navSettings?.railBottomFg)};cursor:pointer;display:flex;align-items:center;justify-content:center;box-shadow:var(--shadow-card)`,
                  )}
                >
                  <i className="ph ph-gear-six" style={{ fontSize: '18px' }}></i>
                </button>{' '}
              </div>{' '}
            </div>{' '}
          </>
        ) : null}{' '}
        {m.navOpen ? (
          <>
            {' '}
            <aside
              style={{
                width: '262px',
                flex: 'none',
                display: 'flex',
                flexDirection: 'column',
                margin: '12px 0 12px 12px',
                borderRadius: '20px',
                background: 'var(--surface)',
                border: '1px solid var(--card-line)',
                boxShadow: 'var(--shadow-card)',
                overflow: 'hidden',
              }}
            >
              {' '}
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '12px 12px 10px' }}>
                {' '}
                <div
                  style={{
                    width: '38px',
                    height: '38px',
                    borderRadius: '12px',
                    background: 'var(--rail)',
                    color: 'var(--rail-ink)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flex: 'none',
                  }}
                >
                  <i className="ph-fill ph-asterisk" style={{ fontSize: '19px' }}></i>
                </div>{' '}
                <div style={{ minWidth: '0', flex: '1' }}>
                  {' '}
                  <div
                    style={{
                      fontSize: '13.5px',
                      fontWeight: '700',
                      letterSpacing: '-0.01em',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    PointFive OS
                  </div>{' '}
                  <div
                    style={{
                      fontSize: '10.5px',
                      color: 'var(--muted)',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    Trading operating system
                  </div>{' '}
                </div>{' '}
                <button
                  className="scp-c0a65d4"
                  onClick={m.toggleFold}
                  title={dc.a(m.foldTitle)}
                  aria-label={dc.a(m.foldTitle)}
                  style={{
                    width: '34px',
                    height: '34px',
                    flex: 'none',
                    borderRadius: '11px',
                    border: 'none',
                    background: 'transparent',
                    color: 'var(--muted)',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <i className={`ph ${dc.s(m.foldIcon)}`} style={{ fontSize: '18px' }}></i>
                </button>{' '}
              </div>{' '}
              <nav
                style={{
                  flex: '1',
                  overflowY: 'auto',
                  padding: '0 12px',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                {' '}
                <div style={{ height: '6px', flex: 'none' }}></div>{' '}
                {(m.navMain ?? []).map((it, i213) => (
                  <Fragment key={i213}>
                    {' '}
                    <div style={{ display: 'contents' }}>
                      {' '}
                      {it?.sepBefore ? (
                        <>
                          {' '}
                          <div
                            style={{ height: '1px', background: 'var(--l8)', margin: '10px 2px 0' }}
                          ></div>{' '}
                          <div
                            style={{
                              fontSize: '9.5px',
                              letterSpacing: '0.13em',
                              textTransform: 'uppercase',
                              color: 'var(--muted2)',
                              fontWeight: '600',
                              padding: '14px 9px 8px',
                            }}
                          >
                            {dc.t(it?.groupLabel)}
                          </div>{' '}
                        </>
                      ) : null}{' '}
                      <button
                        className="scp-051c4c6"
                        onClick={it?.go}
                        style={dc.css(
                          `display:flex;align-items:center;gap:11px;width:100%;padding:9px 11px;border-radius:11px;border:1px solid ${dc.s(it?.bd)};background:${dc.s(it?.bg)};color:${dc.s(it?.fg)};font-size:13px;font-weight:${dc.s(it?.fw)};cursor:pointer;text-align:left;margin-bottom:1px`,
                        )}
                      >
                        <i
                          className={`ph ${dc.s(it?.icon)}`}
                          style={dc.css(`font-size:17px;color:inherit;opacity:${dc.s(it?.icOp)}`)}
                        ></i>
                        <span
                          style={{
                            flex: '1',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                          }}
                        >
                          {dc.t(it?.label)}
                        </span>
                        {it?.count ? (
                          <span
                            style={{
                              fontSize: '11px',
                              color: 'inherit',
                              opacity: '0.6',
                              fontVariantNumeric: 'tabular-nums',
                            }}
                          >
                            {dc.t(it?.count)}
                          </span>
                        ) : null}
                      </button>{' '}
                      {it?.sepAfter ? (
                        <>
                          {' '}
                          <div
                            style={{ height: '1px', background: 'var(--l8)', margin: '11px 2px 3px' }}
                          ></div>{' '}
                        </>
                      ) : null}{' '}
                    </div>{' '}
                  </Fragment>
                ))}{' '}
              </nav>{' '}
              <div
                style={{
                  flex: 'none',
                  padding: '10px 12px 12px',
                  borderTop: '1px solid var(--l6)',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '8px',
                }}
              >
                {' '}
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '0 3px 2px' }}>
                  {' '}
                  <div style={{ minWidth: '0', flex: '1' }}>
                    <div
                      style={{
                        fontSize: '9px',
                        letterSpacing: '0.11em',
                        textTransform: 'uppercase',
                        color: 'var(--muted2)',
                        fontWeight: '600',
                      }}
                    >
                      Last sync
                    </div>
                    <div
                      style={{
                        fontSize: '11px',
                        color: 'var(--muted)',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        fontVariantNumeric: 'tabular-nums',
                      }}
                    >
                      24/07/2026, 15:59:32
                    </div>
                  </div>{' '}
                  <button
                    onClick={m.acctLinkRefresh}
                    className="scp-d4ddd0d"
                    title="Sync now"
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '5px',
                      flex: 'none',
                      fontSize: '11px',
                      fontWeight: '500',
                      padding: '6px 10px',
                      borderRadius: '99px',
                      border: '1px solid var(--l10)',
                      background: 'transparent',
                      color: 'var(--text-mid)',
                      cursor: 'pointer',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    <i className="ph ph-arrows-clockwise" style={{ fontSize: '12px' }}></i>Sync Now
                  </button>{' '}
                </div>{' '}
                <button
                  className="scp-d4ddd0d"
                  onClick={m.lockDayAsk}
                  aria-label="Lock the trading day"
                  title="Manual lockout until the end of the UTC day — confirm required"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '11px',
                    width: '100%',
                    padding: '9px 11px',
                    borderRadius: '11px',
                    border: '1px solid var(--l10)',
                    background: 'transparent',
                    color: 'var(--text-mid)',
                    fontSize: '13px',
                    fontWeight: '500',
                    cursor: 'pointer',
                    textAlign: 'left',
                  }}
                >
                  <i className="ph ph-lock-simple" style={{ fontSize: '17px', color: 'var(--muted)' }}></i>
                  <span style={{ flex: '1' }}>{m.dayLockedUntil ? 'Day Locked' : 'Lock Day'}</span>
                </button>{' '}
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  {' '}
                  <button
                    className="scp-4f3e86a"
                    onClick={m.navSettings?.go}
                    style={dc.css(
                      `display:flex;align-items:center;gap:11px;flex:1;min-width:0;padding:9px 11px;border-radius:11px;border:1px solid ${dc.s(m.navSettings?.bd)};background:${dc.s(m.navSettings?.bg)};color:${dc.s(m.navSettings?.fg)};font-size:13px;font-weight:${dc.s(m.navSettings?.fw)};cursor:pointer;text-align:left`,
                    )}
                    aria-label="Settings"
                  >
                    <i
                      className="ph ph-gear-six"
                      style={dc.css(`font-size:17px;color:${dc.s(m.navSettings?.ic)}`)}
                    ></i>
                    <span
                      style={{
                        flex: '1',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      }}
                    >
                      Settings
                    </span>
                  </button>{' '}
                  <button
                    className="scp-4f3e86a"
                    onClick={m.toggleTheme}
                    title="Toggle theme"
                    style={{
                      width: '38px',
                      height: '38px',
                      flex: 'none',
                      borderRadius: '11px',
                      border: 'none',
                      background: 'transparent',
                      color: 'var(--muted)',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <i className={`ph ${dc.s(m.themeIcon)}`} style={{ fontSize: '17px' }}></i>
                  </button>{' '}
                </div>{' '}
              </div>{' '}
            </aside>{' '}
          </>
        ) : null}{' '}
        <div style={{ flex: '1', display: 'flex', flexDirection: 'column', minWidth: '0' }}>
          {' '}
          <header
            className="titlebar"
            data-titlebar
            style={{
              containerType: 'inline-size',
              position: 'relative',
              flex: 'none',
              height: '52px',
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              margin: '12px 12px 0',
              padding: '0 8px 0 8px',
              borderRadius: '18px',
              border: '1px solid var(--card-line)',
              background: 'var(--surface)',
              boxShadow: 'var(--shadow-card)',
              zIndex: '20',
            }}
          >
            {' '}
            <div style={{ display: 'flex', alignItems: 'center', gap: '4px', flex: 'none' }}>
              {' '}
              <button
                onClick={() => m.gFilterToggle?.('symbols')}
                aria-haspopup="true"
                aria-expanded={m.gFilterOpen === 'symbols'}
                aria-label="Filter by symbol (global)"
                className="scp-df536b2"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '4px',
                  fontSize: '11px',
                  padding: '6px 9px',
                  borderRadius: '99px',
                  border: '1px solid var(--l10)',
                  background: 'transparent',
                  color: 'var(--text-mid)',
                  cursor: 'pointer',
                  whiteSpace: 'nowrap',
                  flex: 'none',
                }}
              >
                <i className="ph ph-funnel" style={{ fontSize: '12px' }}></i>
                <span className="filt-label">{dc.t(m.gSymLabel)}</span>
                <i className="ph ph-caret-down" style={{ fontSize: '10px', color: 'var(--faint)' }}></i>
              </button>{' '}
              <button
                onClick={() => m.gFilterToggle?.('range')}
                aria-haspopup="true"
                aria-expanded={m.gFilterOpen === 'range'}
                aria-label="Filter by date range (global)"
                className="scp-df536b2"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '4px',
                  fontSize: '11px',
                  padding: '6px 9px',
                  borderRadius: '99px',
                  border: '1px solid var(--l10)',
                  background: 'transparent',
                  color: 'var(--text-mid)',
                  cursor: 'pointer',
                  whiteSpace: 'nowrap',
                  flex: 'none',
                }}
              >
                <i className="ph ph-calendar-blank" style={{ fontSize: '12px' }}></i>
                <span className="filt-label">{dc.t(m.gRangeLabel)}</span>
                <i className="ph ph-caret-down" style={{ fontSize: '10px', color: 'var(--faint)' }}></i>
              </button>{' '}
            </div>{' '}
            <div
              style={{
                position: 'absolute',
                left: '50%',
                transform: 'translateX(-50%)',
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                padding: '4px 10px',
                borderRadius: '99px',
                background: 'var(--rail)',
              }}
            >
              {' '}
              {(m.modeBtns ?? []).map((m, i214) => (
                <Fragment key={i214}>
                  {' '}
                  <button
                    className="scp-da87d00"
                    onClick={m?.go}
                    title={dc.a(m?.label)}
                    aria-label={dc.a(m?.label)}
                    style={dc.css(
                      `display:inline-flex;align-items:center;gap:8px;padding:${dc.s(m?.pad)};border-radius:99px;border:none;background:${dc.s(m?.hdrBg)};color:${dc.s(m?.hdrFg)};font-size:12px;font-weight:${dc.s(m?.fw)};cursor:pointer;white-space:nowrap;flex:none`,
                    )}
                  >
                    <span
                      style={dc.css(
                        `width:26px;height:26px;border-radius:50%;border:1px solid ${dc.s(m?.hdrRing)};display:flex;align-items:center;justify-content:center;flex:none`,
                      )}
                    >
                      <i className={`ph ${dc.s(m?.icon)}`} style={{ fontSize: '14px' }}></i>
                    </span>
                    {m?.on ? <>{dc.t(m?.label)}</> : null}
                  </button>{' '}
                </Fragment>
              ))}{' '}
            </div>{' '}
            <div style={{ flex: '1 1 0', minWidth: '0' }}></div>{' '}
            <div
              className="sess-group"
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '4px',
                flex: '0 1 auto',
                minWidth: '0',
                overflow: 'hidden',
                justifyContent: 'flex-end',
              }}
            >
              {' '}
              {(m.sessions ?? []).map((s, i215) => (
                <Fragment key={i215}>
                  {' '}
                  <span
                    className={dc.cx(s?.cls)}
                    title={dc.a(s?.title)}
                    style={dc.css(
                      `display:inline-flex;align-items:center;gap:3px;font-size:9.5px;font-weight:600;letter-spacing:0.02em;padding:5px 6px;border-radius:99px;border:1px solid ${dc.s(s?.bd)};color:${dc.s(s?.fg)};background:${dc.s(s?.bg)};white-space:nowrap;flex:none`,
                    )}
                  >
                    <span
                      style={dc.css(`width:5px;height:5px;border-radius:50%;background:${dc.s(s?.dot)}`)}
                    ></span>
                    {dc.t(s?.name)}
                    <span
                      className="sess-time"
                      style={{ opacity: '0.75', fontWeight: '500', fontVariantNumeric: 'tabular-nums' }}
                    >
                      {dc.t(s?.timeShort)}
                    </span>
                  </span>{' '}
                </Fragment>
              ))}{' '}
            </div>{' '}
            <button
              className="scp-4f3e86a"
              onClick={m.goNotifications}
              title="Notifications"
              aria-label="Notifications"
              style={{
                position: 'relative',
                width: '34px',
                height: '34px',
                flex: 'none',
                borderRadius: '11px',
                border: '1px solid var(--l8)',
                background: 'transparent',
                color: 'var(--text-mid)',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginLeft: '2px',
              }}
            >
              <i className="ph ph-bell" style={{ fontSize: '16px' }}></i>
              <span
                style={{
                  position: 'absolute',
                  top: '-3px',
                  right: '-3px',
                  minWidth: '15px',
                  height: '15px',
                  padding: '0 3px',
                  borderRadius: '99px',
                  background: 'var(--surface)',
                  color: 'var(--neg)',
                  fontSize: '9.5px',
                  fontWeight: '700',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: '1.5px solid var(--neg-fill)',
                }}
              >
                3
              </span>
            </button>{' '}
            <span
              style={{ width: '1px', height: '26px', background: 'var(--l8)', flex: 'none', margin: '0 2px' }}
            ></span>{' '}
            <div data-acct style={{ position: 'relative', flex: 'none' }}>
              {' '}
              <button
                className="scp-4f3e86a"
                onClick={m.toggleAcct}
                title="Account"
                aria-label="Account menu"
                aria-haspopup="menu"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '3px 10px 3px 3px',
                  borderRadius: '99px',
                  border: '1px solid var(--l8)',
                  background: 'transparent',
                  cursor: 'pointer',
                }}
              >
                {' '}
                <span
                  role="img"
                  aria-label={dc.a(m.acctName)}
                  style={dc.css(
                    `width:30px;height:30px;border-radius:50%;background:var(--rail);background-image:${dc.s(m.avatarBg)};background-size:cover;background-position:center;color:${dc.s(m.avatarInkHdr)};display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:700;flex:none`,
                  )}
                >
                  {dc.t(m.avatarInitialsHdr)}
                </span>{' '}
                <i className="ph ph-caret-down" style={{ fontSize: '10px', color: 'var(--muted2)' }}></i>{' '}
              </button>{' '}
              {m.acctOpen ? (
                <>
                  {' '}
                  <div
                    className="pf-pop"
                    role="menu"
                    style={{
                      position: 'absolute',
                      top: 'calc(100% + 10px)',
                      right: '0',
                      width: '262px',
                      borderRadius: '16px',
                      border: '1px solid var(--card-line)',
                      background: 'var(--surface)',
                      boxShadow: 'var(--shadow-float)',
                      padding: '14px',
                      zIndex: '60',
                    }}
                  >
                    {' '}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      {' '}
                      <span
                        role="img"
                        aria-label={dc.a(m.acctName)}
                        style={dc.css(
                          `width:38px;height:38px;border-radius:50%;background:var(--rail);background-image:${dc.s(m.avatarBg)};background-size:cover;background-position:center;color:${dc.s(m.avatarInkHdr)};display:flex;align-items:center;justify-content:center;font-size:13px;font-weight:700;flex:none`,
                        )}
                      >
                        {dc.t(m.avatarInitialsHdr)}
                      </span>{' '}
                      <div style={{ minWidth: '0' }}>
                        {' '}
                        <div
                          style={{
                            fontSize: '13px',
                            fontWeight: '600',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                          }}
                        >
                          {dc.t(m.acctName)}
                        </div>{' '}
                        <div
                          style={{
                            fontSize: '11px',
                            color: 'var(--muted)',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                          }}
                        >
                          {dc.t(m.acctEmail)}
                        </div>{' '}
                      </div>{' '}
                    </div>{' '}
                    <div style={{ height: '1px', background: 'var(--l8)', margin: '12px 0' }}></div>{' '}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      {' '}
                      <div style={{ flex: '1', minWidth: '0' }}>
                        <div
                          style={{
                            fontSize: '9px',
                            letterSpacing: '0.11em',
                            textTransform: 'uppercase',
                            color: 'var(--muted2)',
                            fontWeight: '600',
                          }}
                        >
                          Plan
                        </div>
                        <div style={{ fontSize: '12.5px', fontWeight: '500', marginTop: '2px' }}>
                          {dc.t(m.acctPlan)}
                        </div>
                      </div>{' '}
                      <span
                        style={{
                          fontSize: '9.5px',
                          fontWeight: '600',
                          letterSpacing: '0.05em',
                          padding: '3px 9px',
                          borderRadius: '99px',
                          background: 'color-mix(in srgb, var(--pos) 14%, transparent)',
                          color: 'var(--pos)',
                        }}
                      >
                        ACTIVE
                      </span>{' '}
                    </div>{' '}
                    <button
                      className="scp-84a7026"
                      role="menuitem"
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '9px',
                        width: '100%',
                        marginTop: '10px',
                        padding: '9px 11px',
                        borderRadius: '11px',
                        border: '1px solid color-mix(in srgb, var(--acc-fill) 45%, transparent)',
                        background: 'color-mix(in srgb, var(--acc-fill) 10%, transparent)',
                        color: 'var(--acc)',
                        fontSize: '12.5px',
                        fontWeight: '600',
                        cursor: 'pointer',
                        textAlign: 'left',
                      }}
                      onClick={m.goBilling}
                    >
                      <i className="ph ph-arrow-circle-up" style={{ fontSize: '15px' }}></i>
                      <span style={{ flex: '1' }}>Upgrade plan</span>
                    </button>{' '}
                    <div style={{ height: '1px', background: 'var(--l8)', margin: '12px 0' }}></div>{' '}
                    <a
                      className="scp-4f3e86a"
                      href="#"
                      onClickCapture={(e) => e.preventDefault()}
                      role="menuitem"
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '9px',
                        padding: '9px 11px',
                        borderRadius: '11px',
                        fontSize: '12.5px',
                        fontWeight: '500',
                        color: 'var(--text-mid)',
                        textDecoration: 'none',
                      }}
                      onClick={m.goBilling}
                    >
                      <i
                        className="ph ph-credit-card"
                        style={{ fontSize: '15px', color: 'var(--muted)' }}
                      ></i>
                      <span style={{ flex: '1' }}>Billing</span>
                      <i
                        className="ph ph-caret-right"
                        style={{ fontSize: '11px', color: 'var(--muted2)' }}
                      ></i>
                    </a>{' '}
                    <a
                      className="scp-4f3e86a"
                      href="#"
                      onClickCapture={(e) => e.preventDefault()}
                      role="menuitem"
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '9px',
                        padding: '9px 11px',
                        borderRadius: '11px',
                        fontSize: '12.5px',
                        fontWeight: '500',
                        color: 'var(--text-mid)',
                        textDecoration: 'none',
                      }}
                      onClick={m.goBilling}
                    >
                      <i className="ph ph-receipt" style={{ fontSize: '15px', color: 'var(--muted)' }}></i>
                      <span style={{ flex: '1' }}>Invoices</span>
                      <i
                        className="ph ph-caret-right"
                        style={{ fontSize: '11px', color: 'var(--muted2)' }}
                      ></i>
                    </a>{' '}
                    <a
                      className="scp-4f3e86a"
                      href="#"
                      onClickCapture={(e) => e.preventDefault()}
                      role="menuitem"
                      aria-label="Sign out"
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '9px',
                        padding: '9px 11px',
                        borderRadius: '11px',
                        fontSize: '12.5px',
                        fontWeight: '500',
                        color: 'var(--text-mid)',
                        textDecoration: 'none',
                        borderTop: '1px solid var(--l7)',
                        marginTop: '4px',
                        paddingTop: '11px',
                      }}
                      onClick={m.signOutGo}
                    >
                      <i className="ph ph-sign-out" style={{ fontSize: '15px', color: 'var(--muted)' }}></i>
                      <span style={{ flex: '1' }}>{m.signOutPending ? 'Signing out…' : 'Sign out'}</span>
                    </a>{' '}
                  </div>{' '}
                </>
              ) : null}{' '}
            </div>{' '}
          </header>{' '}
          <main
            data-tb-scroll
            style={{ flex: '1', overflowY: 'auto', overflowX: 'hidden', minHeight: '0', minWidth: '0' }}
          >
            {' '}
            {m.isDashboard ? <SCREENS.Dashboard m={m} /> : null}{' '}
            {m.isWidgets ? <SCREENS.Widgets m={m} /> : null}{' '}
            {m.isBriefing ? <SCREENS.Briefing m={m} /> : null}{' '}
            {m.isPrepare ? <SCREENS.Prepare m={m} /> : null}{' '}
            {m.isRiskRules ? <SCREENS.RiskRules m={m} /> : null}{' '}
            {m.isRiskProfile ? <SCREENS.RiskProfile m={m} /> : null}{' '}
            {m.isStrategies ? <SCREENS.Strategies m={m} /> : null}{' '}
            {m.isTradeHub ? <SCREENS.TradeHub m={m} /> : null}{' '}
            {m.isSignals ? <SCREENS.Signals m={m} /> : null} {m.isTrades ? <SCREENS.Trades m={m} /> : null}{' '}
            {m.isCopyTrading ? <SCREENS.CopyTrading m={m} /> : null}{' '}
            {m.isAnalytics ? <SCREENS.Analytics m={m} /> : null}{' '}
            {m.isAiInsights ? <SCREENS.AiInsights m={m} /> : null}{' '}
            {m.isPfScore ? <SCREENS.PfScore m={m} /> : null} {m.isJournal ? <SCREENS.Journal m={m} /> : null}{' '}
            {m.isReplay ? <SCREENS.Replay m={m} /> : null}{' '}
            {m.isAcctProgress ? <SCREENS.AcctProgress m={m} /> : null}{' '}
            {m.isEod ? <SCREENS.Eod m={m} /> : null} {m.isAccounts ? <SCREENS.Accounts m={m} /> : null}{' '}
            {m.isNotifications ? <SCREENS.Notifications m={m} /> : null}{' '}
            {m.isSettings ? <SCREENS.Settings m={m} /> : null}{' '}
            {m.isCompare ? <SCREENS.Compare m={m} /> : null} {m.isDigest ? <SCREENS.Digest m={m} /> : null}{' '}
            {m.isTradingIdentity ? <SCREENS.TradingIdentity m={m} /> : null}{' '}
            {m.isStub ? <SCREENS.Stub m={m} /> : null}
            {m.isTradingIntel ? <SCREENS.TradingIntel m={m} /> : null}
            {m.isInvestors ? <SCREENS.Investors m={m} /> : null}
            {m.isBilling ? <SCREENS.Billing /> : null}{' '}
          </main>{' '}
        </div>{' '}
        {m.ordModalOpen ? (
          <>
            {' '}
            <div
              className="pf-scrim"
              style={{
                position: 'fixed',
                inset: '0',
                zIndex: '80',
                background: 'color-mix(in srgb, var(--rail) 45%, transparent)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '24px',
              }}
            >
              {' '}
              <div
                className="pf-modal"
                role="dialog"
                aria-label="Confirm order"
                style={{
                  background: 'var(--surface)',
                  border: '1px solid var(--card-line)',
                  borderRadius: '16px',
                  boxShadow: 'var(--shadow-float)',
                  width: '360px',
                  maxWidth: '100%',
                  padding: '18px 20px',
                }}
              >
                {' '}
                <div style={{ fontSize: '13.5px', fontWeight: '500' }}>
                  {'Confirm '}
                  {dc.t(m.ordSideLabel)}
                  {' order'}
                </div>{' '}
                <div style={{ fontSize: '11.5px', color: 'var(--muted)', marginTop: '4px' }}>
                  {'Market order on '}
                  {dc.t(m.ordAccountLabel)}
                  {'. Your Risk Rules have been checked.'}
                </div>{' '}
                <div
                  style={{
                    border: '1px solid var(--l8)',
                    borderRadius: '11px',
                    background: 'var(--l3)',
                    padding: '12px 14px',
                    marginTop: '14px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '8px',
                  }}
                >
                  {' '}
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11.5px' }}>
                    <span style={{ color: 'var(--muted2)' }}>Instrument</span>
                    <span style={{ fontWeight: '500' }}>{dc.t(m.ordSym)}</span>
                  </div>{' '}
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11.5px' }}>
                    <span style={{ color: 'var(--muted2)' }}>Side · lots</span>
                    <span style={{ fontWeight: '500' }}>
                      {dc.t(m.ordSideLabel)}
                      {' · '}
                      {dc.t(m.ordLots)}
                    </span>
                  </div>{' '}
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11.5px' }}>
                    <span style={{ color: 'var(--muted2)' }}>Price</span>
                    <span style={{ fontVariantNumeric: 'tabular-nums' }}>{dc.t(m.ordPx)}</span>
                  </div>{' '}
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11.5px' }}>
                    <span style={{ color: 'var(--muted2)' }}>Stop loss</span>
                    <span style={{ fontVariantNumeric: 'tabular-nums', color: 'var(--neg)' }}>
                      {dc.t(m.ordSlLabel)}
                    </span>
                  </div>{' '}
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11.5px' }}>
                    <span style={{ color: 'var(--muted2)' }}>Take profit</span>
                    <span style={{ fontVariantNumeric: 'tabular-nums', color: 'var(--pos)' }}>
                      {dc.t(m.ordTpLabel)}
                    </span>
                  </div>{' '}
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      fontSize: '11.5px',
                      borderTop: '1px solid var(--l6)',
                      paddingTop: '8px',
                    }}
                  >
                    <span style={{ color: 'var(--muted2)' }}>Risk · R:R</span>
                    <span style={{ fontVariantNumeric: 'tabular-nums' }}>
                      {dc.t(m.ordRisk)}
                      {' · '}
                      {dc.t(m.ordRr)}
                    </span>
                  </div>{' '}
                </div>{' '}
                <div style={{ display: 'flex', gap: '8px', marginTop: '16px' }}>
                  {' '}
                  <button
                    className="scp-4f3e86a"
                    onClick={m.ordCancel}
                    aria-label="Cancel order"
                    style={{
                      flex: '1',
                      fontSize: '12px',
                      padding: '9px',
                      borderRadius: '99px',
                      border: '1px solid var(--l10)',
                      background: 'transparent',
                      color: 'var(--text-mid)',
                      cursor: 'pointer',
                    }}
                  >
                    Cancel
                  </button>{' '}
                  <button
                    className="scp-cc1088e"
                    onClick={m.ordConfirm}
                    aria-label="Confirm and send order"
                    style={dc.css(
                      `flex:1;font-size:12px;font-weight:600;padding:9px;border-radius:99px;border:1px solid ${dc.s(m.ordBtnBd)};background:${dc.s(m.ordBtnBg)};color:${dc.s(m.ordBtnFg)};cursor:pointer`,
                    )}
                  >
                    Send order
                  </button>{' '}
                </div>{' '}
              </div>{' '}
            </div>{' '}
          </>
        ) : null}{' '}
        {m.jModalOpen ? (
          <>
            {' '}
            <div
              className="pf-scrim"
              style={{
                position: 'fixed',
                inset: '0',
                zIndex: '80',
                background: 'color-mix(in srgb, var(--rail) 45%, transparent)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '24px',
              }}
            >
              {' '}
              <div
                className="pf-modal"
                role="dialog"
                aria-label="New journal entry"
                style={{
                  background: 'var(--surface)',
                  border: '1px solid var(--card-line)',
                  borderRadius: '16px',
                  boxShadow: 'var(--shadow-float)',
                  width: '400px',
                  maxWidth: '100%',
                  padding: '18px 20px',
                }}
              >
                {' '}
                <div style={{ fontSize: '13.5px', fontWeight: '500' }}>
                  {'New entry · '}
                  {dc.t(m.jShort)}
                </div>{' '}
                <div style={{ fontSize: '11.5px', color: 'var(--muted)', marginTop: '4px' }}>
                  Log a trade the broker feed missed, or a decision worth keeping.
                </div>{' '}
                <div
                  style={{
                    fontSize: '9px',
                    letterSpacing: '0.11em',
                    textTransform: 'uppercase',
                    color: 'var(--muted2)',
                    fontWeight: '600',
                    marginTop: '14px',
                  }}
                >
                  Symbol
                </div>{' '}
                <input
                  value={dc.v(m.jfSym)}
                  onChange={m.setJfSym}
                  placeholder="GBPJPY"
                  aria-label="Symbol"
                  style={{
                    width: '100%',
                    marginTop: '5px',
                    padding: '8px 12px',
                    borderRadius: '9px',
                    border: '1px solid var(--l10)',
                    background: 'var(--fill)',
                    color: 'var(--text)',
                    fontSize: '12px',
                    outline: 'none',
                  }}
                />{' '}
                <div style={{ display: 'flex', gap: '12px', marginTop: '12px' }}>
                  {' '}
                  <div style={{ flex: '1' }}>
                    {' '}
                    <div
                      style={{
                        fontSize: '9px',
                        letterSpacing: '0.11em',
                        textTransform: 'uppercase',
                        color: 'var(--muted2)',
                        fontWeight: '600',
                      }}
                    >
                      Direction
                    </div>{' '}
                    <div
                      style={{
                        display: 'flex',
                        gap: '2px',
                        padding: '3px',
                        borderRadius: '99px',
                        border: '1px solid var(--l8)',
                        marginTop: '5px',
                      }}
                    >
                      {' '}
                      {(m.jfSideBtns ?? []).map((b, i216) => (
                        <Fragment key={i216}>
                          {' '}
                          <button
                            onClick={b?.go}
                            aria-label={dc.a(b?.label)}
                            style={dc.css(
                              `flex:1;padding:4px 11px;border-radius:99px;border:none;background:${dc.s(b?.bg)};color:${dc.s(b?.fg)};font-size:10.5px;font-weight:600;cursor:pointer`,
                            )}
                          >
                            {dc.t(b?.label)}
                          </button>{' '}
                        </Fragment>
                      ))}{' '}
                    </div>{' '}
                  </div>{' '}
                  <div style={{ width: '110px' }}>
                    {' '}
                    <div
                      style={{
                        fontSize: '9px',
                        letterSpacing: '0.11em',
                        textTransform: 'uppercase',
                        color: 'var(--muted2)',
                        fontWeight: '600',
                      }}
                    >
                      Result (R)
                    </div>{' '}
                    <input
                      value={dc.v(m.jfR)}
                      onChange={m.setJfR}
                      placeholder="1.40"
                      aria-label="Result in R"
                      style={{
                        width: '100%',
                        marginTop: '5px',
                        padding: '8px 12px',
                        borderRadius: '9px',
                        border: '1px solid var(--l10)',
                        background: 'var(--fill)',
                        color: 'var(--text)',
                        fontSize: '12px',
                        outline: 'none',
                        fontVariantNumeric: 'tabular-nums',
                      }}
                    />{' '}
                  </div>{' '}
                </div>{' '}
                <div
                  style={{
                    fontSize: '9px',
                    letterSpacing: '0.11em',
                    textTransform: 'uppercase',
                    color: 'var(--muted2)',
                    fontWeight: '600',
                    marginTop: '12px',
                  }}
                >
                  Strategy
                </div>{' '}
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginTop: '6px' }}>
                  {' '}
                  {(m.jfStratBtns ?? []).map((b, i217) => (
                    <Fragment key={i217}>
                      {' '}
                      <button
                        onClick={b?.go}
                        aria-label={dc.a(b?.label)}
                        style={dc.css(
                          `font-size:10.5px;padding:5px 11px;border-radius:99px;border:1px solid ${dc.s(b?.bd)};background:${dc.s(b?.bg)};color:${dc.s(b?.fg)};cursor:pointer`,
                        )}
                      >
                        {dc.t(b?.label)}
                      </button>{' '}
                    </Fragment>
                  ))}{' '}
                </div>{' '}
                <div
                  style={{
                    fontSize: '9px',
                    letterSpacing: '0.11em',
                    textTransform: 'uppercase',
                    color: 'var(--muted2)',
                    fontWeight: '600',
                    marginTop: '12px',
                  }}
                >
                  Note
                </div>{' '}
                <textarea
                  value={dc.v(m.jfNote)}
                  onChange={m.setJfNote}
                  placeholder="What did you see, and what did you do?"
                  aria-label="Entry note"
                  style={{
                    width: '100%',
                    height: '76px',
                    resize: 'none',
                    marginTop: '5px',
                    padding: '10px 12px',
                    borderRadius: '9px',
                    border: '1px solid var(--l10)',
                    background: 'var(--fill)',
                    color: 'var(--text)',
                    fontSize: '12px',
                    lineHeight: '1.55',
                    outline: 'none',
                    fontFamily: 'inherit',
                  }}
                ></textarea>{' '}
                {m.jfHasErr ? (
                  <>
                    {' '}
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '7px',
                        marginTop: '9px',
                        fontSize: '11px',
                        color: 'var(--neg)',
                      }}
                    >
                      <i className="ph ph-warning-circle" style={{ fontSize: '12px' }}></i>
                      {dc.t(m.jfErr)}
                    </div>{' '}
                  </>
                ) : null}{' '}
                <div style={{ display: 'flex', gap: '8px', marginTop: '16px' }}>
                  {' '}
                  <button
                    className="scp-4f3e86a"
                    onClick={m.jCloseModal}
                    aria-label="Cancel entry"
                    style={{
                      flex: '1',
                      fontSize: '12px',
                      padding: '9px',
                      borderRadius: '99px',
                      border: '1px solid var(--l10)',
                      background: 'transparent',
                      color: 'var(--text-mid)',
                      cursor: 'pointer',
                    }}
                  >
                    Cancel
                  </button>{' '}
                  <button
                    className="scp-84b4671"
                    onClick={m.jfSubmit}
                    aria-label="Save entry"
                    style={{
                      flex: '1',
                      fontSize: '12px',
                      fontWeight: '600',
                      padding: '9px',
                      borderRadius: '99px',
                      border: '1px solid color-mix(in srgb, var(--sky-fill) 50%, transparent)',
                      background: 'color-mix(in srgb, var(--sky-fill) 10%, transparent)',
                      color: 'var(--sky)',
                      cursor: 'pointer',
                    }}
                  >
                    Save entry
                  </button>{' '}
                </div>{' '}
              </div>{' '}
            </div>{' '}
          </>
        ) : null}{' '}
        {m.cpModalOpen ? (
          <>
            {' '}
            <div
              className="pf-scrim"
              style={{
                position: 'fixed',
                inset: '0',
                zIndex: '80',
                background: 'color-mix(in srgb, var(--rail) 45%, transparent)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '24px',
              }}
            >
              {' '}
              <div
                className="pf-modal"
                role="dialog"
                aria-label="Confirm copy subscription"
                style={{
                  background: 'var(--surface)',
                  border: '1px solid var(--card-line)',
                  borderRadius: '16px',
                  boxShadow: 'var(--shadow-float)',
                  width: '380px',
                  maxWidth: '100%',
                  padding: '18px 20px',
                }}
              >
                {' '}
                <div style={{ fontSize: '13.5px', fontWeight: '500' }}>
                  {'Start copying '}
                  {dc.t(m.cpModalName)}
                </div>{' '}
                <div style={{ fontSize: '11.5px', color: 'var(--muted)', marginTop: '4px' }}>
                  Trades mirror into Exness #184745 at your risk multiplier.
                </div>{' '}
                <div
                  style={{
                    border: '1px solid var(--l8)',
                    borderRadius: '11px',
                    background: 'var(--l3)',
                    padding: '12px 14px',
                    marginTop: '14px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '8px',
                  }}
                >
                  {' '}
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11.5px' }}>
                    <span style={{ color: 'var(--muted2)' }}>Provider risk</span>
                    <span style={{ fontWeight: '500' }}>{dc.t(m.cpModalRisk)}</span>
                  </div>{' '}
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11.5px' }}>
                    <span style={{ color: 'var(--muted2)' }}>Provider max drawdown</span>
                    <span style={{ fontVariantNumeric: 'tabular-nums', color: 'var(--neg)' }}>
                      {dc.t(m.cpModalDd)}
                    </span>
                  </div>{' '}
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11.5px' }}>
                    <span style={{ color: 'var(--muted2)' }}>Risk multiplier</span>
                    <span style={{ fontVariantNumeric: 'tabular-nums' }}>{dc.t(m.cpMultLabel)}</span>
                  </div>{' '}
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      fontSize: '11.5px',
                      borderTop: '1px solid var(--l6)',
                      paddingTop: '8px',
                    }}
                  >
                    <span style={{ color: 'var(--muted2)' }}>Allocation</span>
                    <span style={{ fontVariantNumeric: 'tabular-nums' }}>{dc.t(m.cpModalAlloc)}</span>
                  </div>{' '}
                </div>{' '}
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginTop: '13px' }}>
                  {' '}
                  <input
                    type="range"
                    min="0.2"
                    max="3"
                    step="0.1"
                    value={dc.v(m.cpMult)}
                    onChange={m.setCpMult}
                    aria-label="Risk multiplier"
                    style={{ flex: '1' }}
                  />{' '}
                  <span
                    style={{
                      fontSize: '12.5px',
                      fontWeight: '600',
                      fontVariantNumeric: 'tabular-nums',
                      minWidth: '40px',
                      textAlign: 'right',
                    }}
                  >
                    {dc.t(m.cpMultLabel)}
                  </span>{' '}
                </div>{' '}
                <div style={{ display: 'flex', gap: '8px', marginTop: '16px' }}>
                  {' '}
                  <button
                    className="scp-4f3e86a"
                    onClick={m.cpClose}
                    aria-label="Cancel copy subscription"
                    style={{
                      flex: '1',
                      fontSize: '12px',
                      padding: '9px',
                      borderRadius: '99px',
                      border: '1px solid var(--l10)',
                      background: 'transparent',
                      color: 'var(--text-mid)',
                      cursor: 'pointer',
                    }}
                  >
                    Cancel
                  </button>{' '}
                  <button
                    className="scp-6842c79"
                    onClick={m.cpConfirm}
                    aria-label="Confirm copy subscription"
                    style={{
                      flex: '1',
                      fontSize: '12px',
                      fontWeight: '600',
                      padding: '9px',
                      borderRadius: '99px',
                      border: '1px solid color-mix(in srgb, var(--pos) 55%, transparent)',
                      background: 'color-mix(in srgb, var(--pos) 10%, transparent)',
                      color: 'var(--pos)',
                      cursor: 'pointer',
                    }}
                  >
                    Start copying
                  </button>{' '}
                </div>{' '}
              </div>{' '}
            </div>{' '}
          </>
        ) : null}{' '}
        <div
          onClick={m.dayClose}
          aria-hidden="true"
          style={dc.css(
            `position:fixed;inset:0;z-index:70;background:color-mix(in srgb, var(--rail) 38%, transparent);opacity:${dc.s(m.dayScrimOp)};pointer-events:${dc.s(m.dayPanelPe)};transition:opacity var(--dur-3) var(--ease-out)`,
          )}
        ></div>{' '}
        <aside
          role="dialog"
          aria-label="Trading day"
          style={dc.css(
            `position:fixed;top:12px;right:12px;bottom:12px;width:min(468px,calc(100% - 24px));z-index:71;display:flex;flex-direction:column;border-radius:20px;background:var(--surface);border:1px solid var(--card-line);box-shadow:var(--shadow-float);overflow:hidden;opacity:${dc.s(m.dayScrimOp)};transform:translateX(${dc.s(m.dayPanelX)});pointer-events:${dc.s(m.dayPanelPe)};transition:opacity var(--dur-3) var(--ease-out),transform var(--dur-3) var(--ease-out)`,
          )}
        >
          {' '}
          <div style={{ flex: 'none', padding: '14px 18px 12px', borderBottom: '1px solid var(--l6)' }}>
            {' '}
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
              {' '}
              <div style={{ flex: '1', minWidth: '0' }}>
                {' '}
                <div
                  style={{
                    fontSize: '9.5px',
                    letterSpacing: '0.13em',
                    textTransform: 'uppercase',
                    color: 'var(--muted2)',
                    fontWeight: '600',
                  }}
                >
                  Trading day
                </div>{' '}
                <div
                  style={{ fontSize: '15px', fontWeight: '600', letterSpacing: '-0.01em', marginTop: '3px' }}
                >
                  {dc.t(m.dayDate)}
                </div>{' '}
              </div>{' '}
              <button
                className="scp-051c4c6"
                onClick={m.dayClose}
                title="Close"
                aria-label="Close trading day"
                style={{
                  width: '28px',
                  height: '28px',
                  flex: 'none',
                  borderRadius: '9px',
                  border: '1px solid var(--l8)',
                  background: 'transparent',
                  color: 'var(--muted)',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <i className="ph ph-x" style={{ fontSize: '14px' }}></i>
              </button>{' '}
            </div>{' '}
            <div
              style={{
                display: 'flex',
                alignItems: 'flex-end',
                gap: '16px',
                flexWrap: 'wrap',
                marginTop: '12px',
              }}
            >
              {' '}
              <div>
                {' '}
                <div
                  style={{
                    fontSize: '9px',
                    letterSpacing: '0.11em',
                    textTransform: 'uppercase',
                    color: 'var(--muted2)',
                    fontWeight: '600',
                  }}
                >
                  Net P&L
                </div>{' '}
                <div
                  style={dc.css(
                    `font-size:20px;font-weight:600;letter-spacing:-0.02em;color:${dc.s(m.dayPnlFg)};font-variant-numeric:tabular-nums;margin-top:2px`,
                  )}
                >
                  {dc.t(m.dayPnl)}
                </div>{' '}
              </div>{' '}
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '3px',
                  fontSize: '10.5px',
                  color: 'var(--muted)',
                  fontVariantNumeric: 'tabular-nums',
                }}
              >
                {' '}
                <span>
                  {dc.t(m.dayCount)}
                  {' · '}
                  {dc.t(m.dayWr)}
                </span>{' '}
                <span>
                  {'Gross win / loss '}
                  {dc.t(m.dayGross)}
                </span>{' '}
                <span>{dc.t(m.dayRisk)}</span>{' '}
              </div>{' '}
              <div style={{ flex: '1' }}></div>{' '}
              <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                {' '}
                <span
                  style={{
                    fontSize: '10px',
                    padding: '3px 10px',
                    borderRadius: '99px',
                    border: '1px solid var(--l10)',
                    color: 'var(--text-mid)',
                  }}
                >
                  {dc.t(m.dayMood)}
                </span>{' '}
                <span
                  style={{
                    fontSize: '10px',
                    padding: '3px 10px',
                    borderRadius: '99px',
                    border: '1px solid var(--l10)',
                    color: 'var(--muted2)',
                    fontVariantNumeric: 'tabular-nums',
                  }}
                >
                  {dc.t(m.dayEnergy)}
                </span>{' '}
              </div>{' '}
            </div>{' '}
          </div>{' '}
          <div
            style={{
              flex: '1',
              minHeight: '0',
              overflowY: 'auto',
              padding: '14px 18px 20px',
              display: 'flex',
              flexDirection: 'column',
              gap: '12px',
            }}
          >
            {' '}
            <div
              style={{
                border: '1px solid var(--l8)',
                borderRadius: '11px',
                background: 'var(--l3)',
                padding: '12px 14px',
              }}
            >
              {' '}
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                {' '}
                <i className="ph ph-sparkle" style={{ fontSize: '14px', color: 'var(--acc-2)' }}></i>{' '}
                <span
                  style={{
                    fontSize: '9.5px',
                    letterSpacing: '0.13em',
                    textTransform: 'uppercase',
                    color: 'var(--muted2)',
                    fontWeight: '600',
                  }}
                >
                  AI day analysis
                </span>{' '}
                <div style={{ flex: '1' }}></div>{' '}
                {m.dayAiIdle ? (
                  <>
                    {' '}
                    <button
                      className="scp-6741c2e"
                      onClick={m.dayRunAi}
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '6px',
                        fontSize: '11px',
                        fontWeight: '500',
                        padding: '5px 12px',
                        borderRadius: '99px',
                        border: '1px solid color-mix(in srgb, var(--acc-fill) 55%, transparent)',
                        background: 'color-mix(in srgb, var(--acc-fill) 12%, transparent)',
                        color: 'var(--acc-2)',
                        cursor: 'pointer',
                      }}
                    >
                      <i className="ph ph-sparkle" style={{ fontSize: '12px' }}></i>Analyze this day
                    </button>{' '}
                  </>
                ) : null}{' '}
                {m.dayAiLoading ? (
                  <>
                    {' '}
                    <span style={{ fontSize: '10.5px', color: 'var(--muted2)' }}>
                      Reading the session…
                    </span>{' '}
                  </>
                ) : null}{' '}
                {m.dayAiDone ? (
                  <>
                    {' '}
                    <button
                      className="scp-051c4c6"
                      onClick={m.dayRunAi}
                      title="Re-run the analysis"
                      aria-label="Re-run the analysis"
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '5px',
                        fontSize: '10.5px',
                        padding: '4px 10px',
                        borderRadius: '99px',
                        border: '1px solid var(--l10)',
                        background: 'transparent',
                        color: 'var(--muted)',
                        cursor: 'pointer',
                      }}
                    >
                      <i className="ph ph-arrow-clockwise" style={{ fontSize: '11px' }}></i>Re-run
                    </button>{' '}
                  </>
                ) : null}{' '}
              </div>{' '}
              {m.dayAiIdle ? (
                <>
                  {' '}
                  <div
                    style={{ fontSize: '11px', color: 'var(--faint)', lineHeight: '1.55', marginTop: '9px' }}
                  >
                    Reads the day's trades, session notes and journal entry against your armed playbook.
                  </div>{' '}
                </>
              ) : null}{' '}
              {m.dayAiDone ? (
                <>
                  {' '}
                  <div
                    className="pf-in"
                    style={{ marginTop: '10px', display: 'flex', flexDirection: 'column', gap: '9px' }}
                  >
                    {' '}
                    <div style={dc.css(`font-size:12.5px;font-weight:500;color:${dc.s(m.dayAiVerdictFg)}`)}>
                      {dc.t(m.dayAiVerdict)}
                    </div>{' '}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '7px' }}>
                      {' '}
                      {(m.dayAiBullets ?? []).map((b, i218) => (
                        <Fragment key={i218}>
                          {' '}
                          <div style={{ display: 'flex', gap: '8px', alignItems: 'flex-start' }}>
                            {' '}
                            <i
                              className={`ph ${dc.s(b?.icon)}`}
                              style={{
                                fontSize: '13px',
                                color: 'var(--muted2)',
                                flex: 'none',
                                marginTop: '2px',
                              }}
                            ></i>{' '}
                            <span style={{ fontSize: '11.5px', color: 'var(--text2)', lineHeight: '1.55' }}>
                              {dc.t(b?.text)}
                            </span>{' '}
                          </div>{' '}
                        </Fragment>
                      ))}{' '}
                    </div>{' '}
                    <div
                      style={{
                        display: 'flex',
                        gap: '8px',
                        alignItems: 'flex-start',
                        paddingTop: '9px',
                        borderTop: '1px solid var(--l6)',
                      }}
                    >
                      {' '}
                      <i
                        className="ph ph-arrow-bend-down-right"
                        style={{ fontSize: '13px', color: 'var(--acc-2)', flex: 'none', marginTop: '2px' }}
                      ></i>{' '}
                      <span style={{ fontSize: '11.5px', color: 'var(--text)', lineHeight: '1.55' }}>
                        {dc.t(m.dayAiAction)}
                      </span>{' '}
                    </div>{' '}
                  </div>{' '}
                </>
              ) : null}{' '}
            </div>{' '}
            <div>
              {' '}
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <i className="ph ph-note-pencil" style={{ fontSize: '13px', color: 'var(--muted)' }}></i>
                <span
                  style={{
                    fontSize: '9.5px',
                    letterSpacing: '0.13em',
                    textTransform: 'uppercase',
                    color: 'var(--muted2)',
                    fontWeight: '600',
                  }}
                >
                  Session notes
                </span>
                <div
                  style={{
                    flex: '1',
                    height: '1px',
                    background: 'linear-gradient(90deg,var(--l10),transparent)',
                  }}
                ></div>
              </div>{' '}
              <div
                style={{ fontSize: '11.5px', color: 'var(--text2)', lineHeight: '1.65', marginTop: '8px' }}
              >
                {dc.t(m.dayPrep)}
              </div>{' '}
            </div>{' '}
            <div>
              {' '}
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <i className="ph ph-notebook" style={{ fontSize: '13px', color: 'var(--muted)' }}></i>
                <span
                  style={{
                    fontSize: '9.5px',
                    letterSpacing: '0.13em',
                    textTransform: 'uppercase',
                    color: 'var(--muted2)',
                    fontWeight: '600',
                  }}
                >
                  Journal entry
                </span>
                <div
                  style={{
                    flex: '1',
                    height: '1px',
                    background: 'linear-gradient(90deg,var(--l10),transparent)',
                  }}
                ></div>
              </div>{' '}
              <div
                style={{ fontSize: '11.5px', color: 'var(--text2)', lineHeight: '1.65', marginTop: '8px' }}
              >
                {dc.t(m.dayPost)}
              </div>{' '}
              <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginTop: '9px' }}>
                {' '}
                {(m.dayTags ?? []).map((t, i219) => (
                  <Fragment key={i219}>
                    {' '}
                    <span
                      style={{
                        fontSize: '10px',
                        padding: '3px 10px',
                        borderRadius: '99px',
                        border: '1px solid var(--l10)',
                        color: 'var(--muted2)',
                      }}
                    >
                      {dc.t(t)}
                    </span>{' '}
                  </Fragment>
                ))}{' '}
              </div>{' '}
            </div>{' '}
            <div>
              {' '}
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <i className="ph ph-list-dashes" style={{ fontSize: '13px', color: 'var(--muted)' }}></i>
                <span
                  style={{
                    fontSize: '9.5px',
                    letterSpacing: '0.13em',
                    textTransform: 'uppercase',
                    color: 'var(--muted2)',
                    fontWeight: '600',
                  }}
                >
                  Session trades
                </span>
                <div
                  style={{
                    flex: '1',
                    height: '1px',
                    background: 'linear-gradient(90deg,var(--l10),transparent)',
                  }}
                ></div>
                <span
                  style={{ fontSize: '10.5px', color: 'var(--muted2)', fontVariantNumeric: 'tabular-nums' }}
                >
                  {dc.t(m.dayCount)}
                </span>
              </div>{' '}
              <div
                style={{
                  border: '1px solid var(--l8)',
                  borderRadius: '11px',
                  overflow: 'hidden',
                  marginTop: '9px',
                }}
              >
                {' '}
                {(m.dayTrades ?? []).map((t, i220) => (
                  <Fragment key={i220}>
                    {' '}
                    <div
                      style={dc.css(
                        `display:flex;align-items:center;gap:10px;padding:9px 11px;border-bottom:1px solid var(--l6);background:${dc.s(t?.bg)}`,
                      )}
                    >
                      {' '}
                      <span
                        style={{
                          fontSize: '10.5px',
                          color: 'var(--muted)',
                          fontVariantNumeric: 'tabular-nums',
                          width: '38px',
                          flex: 'none',
                        }}
                      >
                        {dc.t(t?.time)}
                      </span>{' '}
                      <div style={{ flex: '1', minWidth: '0' }}>
                        {' '}
                        <div style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
                          <span style={{ fontSize: '11.5px', fontWeight: '600' }}>{dc.t(t?.sym)}</span>
                          <span
                            style={{
                              fontSize: '9px',
                              letterSpacing: '0.08em',
                              color: 'var(--muted2)',
                              fontWeight: '600',
                            }}
                          >
                            {dc.t(t?.side)}
                          </span>
                          <span
                            style={{
                              fontSize: '10px',
                              color: 'var(--faint)',
                              fontVariantNumeric: 'tabular-nums',
                            }}
                          >
                            {dc.t(t?.lots)}
                          </span>
                        </div>{' '}
                        <div
                          style={{
                            fontSize: '10px',
                            color: 'var(--muted2)',
                            marginTop: '2px',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                          }}
                        >
                          {dc.t(t?.strat)}
                          {' · '}
                          {dc.t(t?.sess)}
                        </div>{' '}
                      </div>{' '}
                      <div style={{ textAlign: 'right', flex: 'none' }}>
                        {' '}
                        <div
                          style={dc.css(
                            `font-size:11.5px;font-weight:600;color:${dc.s(t?.pnlFg)};font-variant-numeric:tabular-nums`,
                          )}
                        >
                          {dc.t(t?.pnlLabel)}
                        </div>{' '}
                        <div
                          style={dc.css(
                            `font-size:10px;color:${dc.s(t?.pnlFg)};font-variant-numeric:tabular-nums;opacity:0.75`,
                          )}
                        >
                          {dc.t(t?.r)}
                        </div>{' '}
                      </div>{' '}
                    </div>{' '}
                  </Fragment>
                ))}{' '}
              </div>{' '}
            </div>{' '}
            <div>
              {' '}
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <i className="ph ph-camera" style={{ fontSize: '13px', color: 'var(--muted)' }}></i>
                <span
                  style={{
                    fontSize: '9.5px',
                    letterSpacing: '0.13em',
                    textTransform: 'uppercase',
                    color: 'var(--muted2)',
                    fontWeight: '600',
                  }}
                >
                  Screenshots
                </span>
                <div
                  style={{
                    flex: '1',
                    height: '1px',
                    background: 'linear-gradient(90deg,var(--l10),transparent)',
                  }}
                ></div>
                <span style={{ fontSize: '10.5px', color: 'var(--muted2)' }}>{dc.t(m.dayShotCount)}</span>
              </div>{' '}
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,124px),1fr))',
                  gap: '8px',
                  marginTop: '9px',
                }}
              >
                {' '}
                {(m.dayShots ?? []).map((s, i221) => (
                  <Fragment key={i221}>
                    {' '}
                    <div
                      style={dc.css(
                        `border:1px solid ${dc.s(s?.bd)};background:${dc.s(s?.bg)};border-radius:11px;padding:8px;display:flex;flex-direction:column;gap:6px`,
                      )}
                    >
                      {' '}
                      <div
                        style={{
                          height: '58px',
                          borderRadius: '8px',
                          border: '1px solid var(--l8)',
                          background: 'var(--l4)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <i className="ph ph-chart-line" style={{ fontSize: '17px', color: 'var(--l14)' }}></i>
                      </div>{' '}
                      <div style={{ display: 'flex', alignItems: 'baseline', gap: '6px' }}>
                        <span style={{ fontSize: '10.5px', fontWeight: '600' }}>{dc.t(s?.sym)}</span>
                        <span
                          style={{
                            fontSize: '9.5px',
                            color: 'var(--faint)',
                            fontVariantNumeric: 'tabular-nums',
                          }}
                        >
                          {dc.t(s?.time)}
                        </span>
                      </div>{' '}
                      <span
                        style={{
                          fontSize: '9px',
                          letterSpacing: '0.09em',
                          textTransform: 'uppercase',
                          color: 'var(--muted2)',
                          fontWeight: '600',
                        }}
                      >
                        {dc.t(s?.phase)}
                      </span>{' '}
                    </div>{' '}
                  </Fragment>
                ))}{' '}
              </div>{' '}
            </div>{' '}
          </div>{' '}
        </aside>{' '}
        <div
          onClick={m.drClose}
          aria-hidden="true"
          style={dc.css(
            `position:fixed;inset:0;z-index:72;background:color-mix(in srgb, var(--rail) 38%, transparent);opacity:${dc.s(m.drOp)};pointer-events:${dc.s(m.drPe)};transition:opacity var(--dur-3) var(--ease-out)`,
          )}
        ></div>{' '}
        <aside
          role="dialog"
          aria-label="Metric detail"
          style={dc.css(
            `position:fixed;top:12px;right:12px;bottom:12px;width:min(430px,calc(100% - 24px));z-index:73;display:flex;flex-direction:column;border-radius:20px;background:var(--surface);border:1px solid var(--card-line);box-shadow:var(--shadow-float);overflow:hidden;opacity:${dc.s(m.drOp)};transform:translateX(${dc.s(m.drX)});pointer-events:${dc.s(m.drPe)};transition:opacity var(--dur-3) var(--ease-out),transform var(--dur-3) var(--ease-out)`,
          )}
        >
          {' '}
          <div style={{ flex: 'none', padding: '14px 18px 12px', borderBottom: '1px solid var(--l6)' }}>
            {' '}
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
              {' '}
              <div style={{ flex: '1', minWidth: '0' }}>
                {' '}
                <div
                  style={{
                    fontSize: '9.5px',
                    letterSpacing: '0.13em',
                    textTransform: 'uppercase',
                    color: 'var(--muted2)',
                    fontWeight: '600',
                  }}
                >
                  {dc.t(m.drKicker)}
                </div>{' '}
                <div
                  style={{ fontSize: '15px', fontWeight: '600', letterSpacing: '-0.01em', marginTop: '3px' }}
                >
                  {dc.t(m.drTitle)}
                </div>{' '}
              </div>{' '}
              <button
                className="scp-051c4c6"
                onClick={m.drClose}
                title="Close"
                aria-label="Close metric detail"
                style={{
                  width: '28px',
                  height: '28px',
                  flex: 'none',
                  borderRadius: '9px',
                  border: '1px solid var(--l8)',
                  background: 'transparent',
                  color: 'var(--muted)',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <i className="ph ph-x" style={{ fontSize: '14px' }}></i>
              </button>{' '}
            </div>{' '}
            <div
              style={{
                display: 'flex',
                alignItems: 'baseline',
                gap: '10px',
                flexWrap: 'wrap',
                marginTop: '11px',
              }}
            >
              {' '}
              <span
                style={dc.css(
                  `font-size:26px;font-weight:600;letter-spacing:-0.02em;line-height:1.1;font-variant-numeric:tabular-nums;color:${dc.s(m.drValueCol)}`,
                )}
              >
                {dc.t(m.drValue)}
              </span>{' '}
              <span
                style={dc.css(
                  `font-size:11.5px;font-weight:600;font-variant-numeric:tabular-nums;color:${dc.s(m.drDeltaCol)}`,
                )}
              >
                {dc.t(m.drDelta)}
              </span>{' '}
            </div>{' '}
            <div style={{ fontSize: '10.5px', color: 'var(--muted)', marginTop: '3px' }}>
              {dc.t(m.drSub)}
            </div>{' '}
          </div>{' '}
          <div
            style={{
              flex: '1',
              minHeight: '0',
              overflowY: 'auto',
              padding: '14px 18px 18px',
              display: 'flex',
              flexDirection: 'column',
              gap: '13px',
            }}
          >
            {' '}
            <div style={{ fontSize: '11.5px', color: 'var(--text2)', lineHeight: '1.65' }}>
              {dc.t(m.drBody)}
            </div>{' '}
            {m.drHasStats ? (
              <>
                {' '}
                <div
                  style={{
                    border: '1px solid var(--l8)',
                    borderRadius: '11px',
                    background: 'var(--l3)',
                    padding: '11px 13px',
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit,minmax(108px,1fr))',
                    gap: '10px',
                  }}
                >
                  {' '}
                  {(m.drStats ?? []).map((s, i222) => (
                    <Fragment key={i222}>
                      {' '}
                      <div style={{ minWidth: '0' }}>
                        {' '}
                        <div
                          style={{
                            fontSize: '9px',
                            letterSpacing: '0.11em',
                            textTransform: 'uppercase',
                            color: 'var(--muted2)',
                            fontWeight: '600',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                          }}
                        >
                          {dc.t(s?.label)}
                        </div>{' '}
                        <div
                          style={dc.css(
                            `font-size:13px;font-weight:600;font-variant-numeric:tabular-nums;margin-top:2px;color:${dc.s(s?.col)}`,
                          )}
                        >
                          {dc.t(s?.value)}
                        </div>{' '}
                      </div>{' '}
                    </Fragment>
                  ))}{' '}
                </div>{' '}
              </>
            ) : null}{' '}
            {m.drHasTrend ? (
              <>
                {' '}
                <div>
                  {' '}
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <i className="ph ph-chart-bar" style={{ fontSize: '13px', color: 'var(--muted)' }}></i>
                    <span
                      style={{
                        fontSize: '9.5px',
                        letterSpacing: '0.13em',
                        textTransform: 'uppercase',
                        color: 'var(--muted2)',
                        fontWeight: '600',
                      }}
                    >
                      {dc.t(m.drTrendTitle)}
                    </span>
                    <div
                      style={{
                        flex: '1',
                        height: '1px',
                        background: 'linear-gradient(90deg,var(--l10),transparent)',
                      }}
                    ></div>
                  </div>{' '}
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'flex-end',
                      gap: '5px',
                      height: '58px',
                      marginTop: '10px',
                    }}
                  >
                    {' '}
                    {(m.drTrend ?? []).map((t, i223) => (
                      <Fragment key={i223}>
                        {' '}
                        <div
                          onMouseEnter={t?.hEnter}
                          onMouseMove={t?.hMove}
                          onMouseLeave={t?.hLeave}
                          style={{
                            flex: '1',
                            minWidth: '0',
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'flex-end',
                            gap: '4px',
                            cursor: 'default',
                          }}
                        >
                          {' '}
                          <div
                            style={dc.css(
                              `width:100%;height:${dc.s(t?.h)};min-height:3px;border-radius:3px;background:${dc.s(t?.col)};opacity:${dc.s(t?.op)}`,
                            )}
                          ></div>{' '}
                          <span
                            style={{
                              fontSize: '8.5px',
                              color: 'var(--faint)',
                              textAlign: 'center',
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                            }}
                          >
                            {dc.t(t?.label)}
                          </span>{' '}
                        </div>{' '}
                      </Fragment>
                    ))}{' '}
                  </div>{' '}
                </div>{' '}
              </>
            ) : null}{' '}
            {m.drHasRows ? (
              <>
                {' '}
                <div>
                  {' '}
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <i
                      className={`ph ${dc.s(m.drRowsIcon)}`}
                      style={{ fontSize: '13px', color: 'var(--muted)' }}
                    ></i>
                    <span
                      style={{
                        fontSize: '9.5px',
                        letterSpacing: '0.13em',
                        textTransform: 'uppercase',
                        color: 'var(--muted2)',
                        fontWeight: '600',
                      }}
                    >
                      {dc.t(m.drRowsTitle)}
                    </span>
                    <div
                      style={{
                        flex: '1',
                        height: '1px',
                        background: 'linear-gradient(90deg,var(--l10),transparent)',
                      }}
                    ></div>
                    <span
                      style={{
                        fontSize: '10.5px',
                        color: 'var(--muted2)',
                        fontVariantNumeric: 'tabular-nums',
                      }}
                    >
                      {dc.t(m.drRowsMeta)}
                    </span>
                  </div>{' '}
                  <div
                    style={{
                      border: '1px solid var(--l8)',
                      borderRadius: '11px',
                      overflow: 'hidden',
                      marginTop: '9px',
                    }}
                  >
                    {' '}
                    {(m.drRows ?? []).map((r, i224) => (
                      <Fragment key={i224}>
                        {' '}
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px',
                            padding: '9px 11px',
                            borderBottom: '1px solid var(--l6)',
                          }}
                        >
                          {' '}
                          <span
                            style={{
                              fontSize: '10.5px',
                              color: 'var(--muted)',
                              fontVariantNumeric: 'tabular-nums',
                              width: '46px',
                              flex: 'none',
                            }}
                          >
                            {dc.t(r?.lead)}
                          </span>{' '}
                          <div style={{ flex: '1', minWidth: '0' }}>
                            {' '}
                            <div
                              style={{
                                fontSize: '11.5px',
                                fontWeight: '600',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                              }}
                            >
                              {dc.t(r?.name)}
                            </div>{' '}
                            <div
                              style={{
                                fontSize: '10px',
                                color: 'var(--muted2)',
                                marginTop: '2px',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                              }}
                            >
                              {dc.t(r?.sub)}
                            </div>{' '}
                          </div>{' '}
                          <div style={{ textAlign: 'right', flex: 'none' }}>
                            {' '}
                            <div
                              style={dc.css(
                                `font-size:11.5px;font-weight:600;color:${dc.s(r?.col)};font-variant-numeric:tabular-nums`,
                              )}
                            >
                              {dc.t(r?.value)}
                            </div>{' '}
                            <div
                              style={{
                                fontSize: '10px',
                                color: 'var(--muted2)',
                                fontVariantNumeric: 'tabular-nums',
                              }}
                            >
                              {dc.t(r?.meta)}
                            </div>{' '}
                          </div>{' '}
                        </div>{' '}
                      </Fragment>
                    ))}{' '}
                  </div>{' '}
                </div>{' '}
              </>
            ) : null}{' '}
            {m.drHasNotes ? (
              <>
                {' '}
                <div>
                  {' '}
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <i className="ph ph-lightbulb" style={{ fontSize: '13px', color: 'var(--muted)' }}></i>
                    <span
                      style={{
                        fontSize: '9.5px',
                        letterSpacing: '0.13em',
                        textTransform: 'uppercase',
                        color: 'var(--muted2)',
                        fontWeight: '600',
                      }}
                    >
                      What's driving it
                    </span>
                    <div
                      style={{
                        flex: '1',
                        height: '1px',
                        background: 'linear-gradient(90deg,var(--l10),transparent)',
                      }}
                    ></div>
                  </div>{' '}
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '9px' }}>
                    {' '}
                    {(m.drNotes ?? []).map((n, i225) => (
                      <Fragment key={i225}>
                        {' '}
                        <div style={{ display: 'flex', gap: '8px', alignItems: 'flex-start' }}>
                          {' '}
                          <i
                            className={`ph ${dc.s(n?.icon)}`}
                            style={dc.css(`font-size:13px;color:${dc.s(n?.col)};flex:none;margin-top:2px`)}
                          ></i>{' '}
                          <span style={{ fontSize: '11.5px', color: 'var(--text2)', lineHeight: '1.55' }}>
                            {dc.t(n?.text)}
                          </span>{' '}
                        </div>{' '}
                      </Fragment>
                    ))}{' '}
                  </div>{' '}
                </div>{' '}
              </>
            ) : null}{' '}
          </div>{' '}
          <div
            style={{
              flex: 'none',
              padding: '12px 18px 14px',
              borderTop: '1px solid var(--l6)',
              display: 'flex',
              flexDirection: 'column',
              gap: '7px',
            }}
          >
            {' '}
            <button
              className="scp-6741c2e"
              onClick={m.drCta}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                width: '100%',
                padding: '10px',
                borderRadius: '99px',
                border: '1px solid color-mix(in srgb, var(--acc-fill) 55%, transparent)',
                background: 'color-mix(in srgb, var(--acc-fill) 12%, transparent)',
                color: 'var(--acc)',
                fontSize: '12px',
                fontWeight: '600',
                cursor: 'pointer',
              }}
            >
              <i className={`ph ${dc.s(m.drCtaIcon)}`} style={{ fontSize: '14px' }}></i>
              {dc.t(m.drCtaLabel)}
            </button>{' '}
            <span style={{ fontSize: '9.5px', color: 'var(--faint)', textAlign: 'center' }}>
              {dc.t(m.drCtaHint)}
            </span>{' '}
          </div>{' '}
        </aside>{' '}
        <div
          ref={m.tipRef}
          role="tooltip"
          aria-hidden="true"
          style={dc.css(
            `position:fixed;left:0;top:0;z-index:95;max-width:252px;border-radius:11px;border:1px solid var(--card-line);background:var(--surface);box-shadow:var(--shadow-float);padding:8px 11px;display:flex;flex-direction:column;gap:4px;opacity:${dc.s(m.tipOp)};pointer-events:none;transition:opacity var(--dur-1) var(--ease-out)`,
          )}
        >
          {' '}
          <span
            style={{
              fontSize: '9px',
              letterSpacing: '0.11em',
              textTransform: 'uppercase',
              color: 'var(--muted2)',
              fontWeight: '600',
            }}
          >
            {dc.t(m.tipHead)}
          </span>{' '}
          <span
            style={dc.css(
              `font-size:14px;font-weight:600;letter-spacing:-0.01em;font-variant-numeric:tabular-nums;color:${dc.s(m.tipValueCol)}`,
            )}
          >
            {dc.t(m.tipValue)}
          </span>{' '}
          {(m.tipRows ?? []).map((r, i226) => (
            <Fragment key={i226}>
              {' '}
              <div style={{ display: 'flex', alignItems: 'baseline', gap: '12px' }}>
                {' '}
                <span
                  style={{
                    flex: '1',
                    minWidth: '0',
                    fontSize: '10.5px',
                    color: 'var(--muted)',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {dc.t(r?.k)}
                </span>{' '}
                <span
                  style={dc.css(
                    `font-size:10.5px;font-weight:600;font-variant-numeric:tabular-nums;color:${dc.s(r?.col)};white-space:nowrap`,
                  )}
                >
                  {dc.t(r?.v)}
                </span>{' '}
              </div>{' '}
            </Fragment>
          ))}{' '}
          <span style={{ fontSize: '9.5px', color: 'var(--faint)', lineHeight: '1.45' }}>
            {dc.t(m.tipNote)}
          </span>{' '}
        </div>{' '}
        <div
          role="status"
          aria-live="polite"
          style={dc.css(
            `position:fixed;bottom:24px;left:50%;z-index:90;background:var(--surface);border:1px solid var(--card-line);border-radius:16px;box-shadow:var(--shadow-float);display:flex;align-items:center;gap:9px;padding:11px 16px;max-width:min(440px,90vw);opacity:${dc.s(m.toastOp)};transform:translateX(-50%) translateY(${dc.s(m.toastY)});pointer-events:none;transition:opacity ${dc.s(m.toastDur)} var(--ease-out),transform ${dc.s(m.toastDur)} var(--ease-out)`,
          )}
        >
          {' '}
          <i
            className={`ph ${dc.s(m.toastIcon)}`}
            style={dc.css(`font-size:15px;color:${dc.s(m.toastFg)};flex:none`)}
          ></i>{' '}
          <span style={{ fontSize: '11.5px', color: 'var(--text-mid)', lineHeight: '1.5' }}>
            {dc.t(m.toast)}
          </span>{' '}
        </div>{' '}
        <div
          style={{
            position: 'fixed',
            bottom: '22px',
            right: '22px',
            zIndex: '60',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
            gap: '12px',
          }}
          data-composer-stack=""
        >
          {' '}
          {m.composerOpen ? (
            <>
              {' '}
              <div
                style={{
                  width: '360px',
                  background: 'var(--surface)',
                  border: '1px solid var(--l10)',
                  borderRadius: '16px',
                  boxShadow: 'var(--shadow-float)',
                  overflow: 'hidden',
                }}
              >
                {' '}
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '9px',
                    padding: '13px 15px',
                    borderBottom: '1px solid var(--l7)',
                  }}
                >
                  {' '}
                  <div
                    style={{
                      width: '22px',
                      height: '22px',
                      borderRadius: '7px',
                      background: 'var(--rail)',
                      color: 'var(--rail-ink)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flex: 'none',
                    }}
                  >
                    <i className="ph-fill ph-robot" style={{ fontSize: '13px' }}></i>
                  </div>{' '}
                  <span style={{ fontSize: '12.5px', fontWeight: '600' }}>Ask PointFive</span>{' '}
                  <span
                    style={{
                      fontSize: '9px',
                      fontWeight: '600',
                      letterSpacing: '0.06em',
                      padding: '2px 7px',
                      borderRadius: '99px',
                      border: '1px solid var(--l12)',
                      color: 'var(--muted)',
                    }}
                  >
                    ⌘K
                  </span>{' '}
                  <div style={{ flex: '1' }}></div>{' '}
                  <button
                    className="scp-4f3e86a"
                    onClick={m.toggleComposer}
                    style={{
                      width: '24px',
                      height: '24px',
                      border: 'none',
                      background: 'transparent',
                      color: 'var(--muted2)',
                      cursor: 'pointer',
                      borderRadius: '6px',
                    }}
                    aria-label="Remove"
                  >
                    <i className="ph ph-x" style={{ fontSize: '13px' }}></i>
                  </button>{' '}
                </div>{' '}
                <div style={{ padding: '13px 15px' }}>
                  {' '}
                  <input
                    placeholder="Analyse my XAUUSD trades…"
                    style={{
                      width: '100%',
                      padding: '10px 13px',
                      borderRadius: '10px',
                      border: '1px solid var(--l10)',
                      background: 'var(--fill)',
                      color: 'var(--text)',
                      fontSize: '12.5px',
                      outline: 'none',
                    }}
                    aria-label="Ask PointFive"
                    value={dc.v(m.composerQuery)}
                    onChange={m.composerSet}
                    onKeyDown={m.composerKey}
                  />{' '}
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginTop: '11px' }}>
                    {' '}
                    {(m.composerChips ?? []).map((c, i227) => (
                      <Fragment key={i227}>
                        {' '}
                        <span
                          className="scp-151c22a"
                          style={{
                            fontSize: '10.5px',
                            padding: '5px 11px',
                            borderRadius: '99px',
                            border: '1px solid var(--l10)',
                            color: 'var(--text-mid)',
                            cursor: 'pointer',
                          }}
                          onClick={() => m.composerAsk?.(String(c))}
                          role="button"
                          tabIndex={0}
                        >
                          {dc.t(c)}
                        </span>{' '}
                      </Fragment>
                    ))}{' '}
                  </div>{' '}
                </div>{' '}
              </div>{' '}
            </>
          ) : null}{' '}
          <div style={{ position: 'relative', width: '60px', height: '60px', flex: 'none' }}>
            {' '}
            <div
              className="pf-ai-ring"
              style={{
                position: 'absolute',
                inset: '0',
                borderRadius: '50%',
                background:
                  'conic-gradient(from 0deg,var(--acc-fill),var(--sky-fill),var(--pos),var(--amb),var(--vio-fill),var(--acc-fill))',
              }}
            ></div>{' '}
            <button
              className="scp-98f6321"
              onClick={m.toggleComposer}
              title="Ask PointFive"
              aria-label="Ask PointFive"
              style={{
                position: 'absolute',
                inset: '2px',
                borderRadius: '50%',
                border: '1px solid var(--rail-line)',
                background: 'var(--rail)',
                color: 'var(--rail-ink)',
                boxShadow: 'var(--shadow-float)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                transition: 'background var(--dur-2) var(--ease-out)',
              }}
            >
              <i className="ph-fill ph-robot" style={{ fontSize: '24px' }}></i>
            </button>{' '}
          </div>{' '}
        </div>
      </div>
    </>
  );
}
